"use client";

export const BoxyFitTshirtSizeChart = () => (
  <div className="overflow-x-auto" aria-label="Boy fit size chart">
    <table className="min-w-full border-collapse text-sm sm:text-base">
      <caption className="text-left font-semibold p-2 sm:p-3">
        Boy Fit — Size Chart (cm)
      </caption>
      <thead>
        <tr className="bg-gray-100 text-left">
          <th scope="col" className="px-4 py-2 font-medium">
            Brand Size
          </th>
          <th scope="col" className="px-4 py-2 font-medium">
            Chest (cm)
          </th>
          <th scope="col" className="px-4 py-2 font-medium">
            Length (cm)
          </th>
          <th scope="col" className="px-4 py-2 font-medium">
            Shoulder (cm)
          </th>
          <th scope="col" className="px-4 py-2 font-medium">
            Sleeve Length (cm)
          </th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        <tr>
          <th scope="row" className="px-4 py-2 text-gray-700 font-medium">
            S
          </th>
          <td className="px-4 py-2 text-center">108.0</td>
          <td className="px-4 py-2 text-center">73.4</td>
          <td className="px-4 py-2 text-center">56.4</td>
          <td className="px-4 py-2 text-center">19.1</td>
        </tr>
        <tr>
          <th scope="row" className="px-4 py-2 text-gray-700 font-medium">
            M
          </th>
          <td className="px-4 py-2 text-center">112.0</td>
          <td className="px-4 py-2 text-center">74.9</td>
          <td className="px-4 py-2 text-center">57.9</td>
          <td className="px-4 py-2 text-center">19.6</td>
        </tr>
        <tr>
          <th scope="row" className="px-4 py-2 text-gray-700 font-medium">
            L
          </th>
          <td className="px-4 py-2 text-center">116.1</td>
          <td className="px-4 py-2 text-center">76.7</td>
          <td className="px-4 py-2 text-center">59.4</td>
          <td className="px-4 py-2 text-center">20.1</td>
        </tr>
        <tr>
          <th scope="row" className="px-4 py-2 text-gray-700 font-medium">
            XL
          </th>
          <td className="px-4 py-2 text-center">124.0</td>
          <td className="px-4 py-2 text-center">78.7</td>
          <td className="px-4 py-2 text-center">62.5</td>
          <td className="px-4 py-2 text-center">20.6</td>
        </tr>
        <tr>
          <th scope="row" className="px-4 py-2 text-gray-700 font-medium">
            XXL
          </th>
          <td className="px-4 py-2 text-center">132.1</td>
          <td className="px-4 py-2 text-center">80.8</td>
          <td className="px-4 py-2 text-center">65.5</td>
          <td className="px-4 py-2 text-center">21.1</td>
        </tr>
      </tbody>
    </table>
  </div>
);
